import type { ReactNode } from "react";

import { cn } from "../../lib/utils";
import { SidebarCollapsedTrigger } from "../ui/sidebar";

type OperatorsSubpageShellProps = {
  actions?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  header: ReactNode;
};

export function OperatorsSubpageShell({
  actions,
  children,
  contentClassName,
  header,
}: OperatorsSubpageShellProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col bg-background text-foreground">
      <header className="flex min-h-12 items-center justify-between gap-3 border-b border-border px-3 py-2">
        <div className="flex min-w-0 items-center gap-2">
          <SidebarCollapsedTrigger className="size-7 shrink-0" />
          {header}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </header>
      <main className="min-h-0 flex-1 overflow-y-auto px-4 py-6 sm:px-8">
        <div className={cn("mx-auto w-full", contentClassName)}>{children}</div>
      </main>
    </div>
  );
}
